import React, { useEffect, useState } from "react";
import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from "../../../constants/CustomDropdown";
import {
  addProfileData,
} from "../../../redux/actions/userAction";

import { getdepartmentData } from "../../../redux/actions/dataAction";
import { connect } from "react-redux";
import CustomTextArea from "../../../constants/CustomTextArea";
import CustomButton from "../../../constants/CustomButton";
import CustomInput from "../../../constants/CustomInput";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";


const users_schema = Yup.object().shape({
  first_name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  last_name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
});

const Users = (props) => {
  useEffect(() => {
    props.getdepartmentData();
  }, []);
  return (
    <div className="customContainer">
      <div>
        <CustomHeading title="Add User" />
        <Formik
          initialValues={{
            title:"",
            first_name: "",
            last_name: "",
            blood_group: "",
            phone_number: "",
            date_of_birth:"",
            aadhar_number:"",
            present_address:"",
            department:"",
            website:"",
            image:"",
            other_detail:"",
            email: "admin@test.com",
          }}
          validationSchema={users_schema}
          onSubmit={(values) => {
            props.addProfileData(values);
            props.history.push("/configuration/users");
          }}
        >
          {({ errors, touched, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit} style={{marginTop:0}}>
              <div className="row">
                <div className="col-md-4">
                  <CustomDropdown
                  id="title"
                    label="Title :"
                    data={[
                      { value: "Mr." },
                      { value: "Ms." },
                      { value: "Dr." },
                    ]}
                    notDefaultOption
                    defaultOption={"Select Title"}
                    onChange={handleChange("title")}
                  />
                </div>
                <div className="col-md-4">
                  <CustomDropdown
                    id="blood_group"
                    label="Blood group :"
                    data={[{ value: "A+" }, { value: "B+" }, { value: "AB+" }]}
                    notDefaultOption
                    defaultOption={"Select Blood Group"}
                    onChange={handleChange("blood_group")}
                  />
                </div>
                <div className="col-md-4">
                  <CustomDropdown
                    id="department"
                    label="Department :"
                    data={props?.department?.data?.map((d) => {
                      return { value: d.name };
                    })}
                    notDefaultOption
                    defaultOption={"Select Department"}
                    onChange={handleChange("department")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <CustomInput
                    type={"text"}
                    id="first_name"
                    label={"First Name :"}
                    onChange={handleChange("first_name")}
                    errorText={
                      errors.first_name && touched.first_name ?errors.first_name :null
                    }
                  />
                </div>
                <div className="col-md-6">
                  <CustomInput
                    type={"text"}
                    id="last_name"
                    label={"Last Name :"}
                    onChange={handleChange("last_name")}
                    errorText={
                      errors.last_name && touched.last_name ?errors.last_name :null
                    }
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <CustomInput
                    type={"text"}
                    id="phone_number"
                    label={"Phone Number :"}
                    onChange={handleChange("phone_number")}
                  />
                </div>
                <div className="col-md-6">
                  <CustomInput
                    type={"date"}
                    id="date_of_birth"
                    label={"Date of Birth :"}
                    onChange={handleChange("date_of_birth")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <CustomInput
                    type={"text"}
                    id="aadhar_number"
                    label={"Aadhar Number :"}
                    onChange={handleChange("aadhar_number")}
                  />
                </div>
                <div className="col-md-6">
                  <CustomInput
                    type={"text"}
                    id="website"
                    label={"Website :"}
                    onChange={handleChange("website")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <CustomTextArea
                    id="present_address"
                    label={"Present Address :"}
                    onChange={handleChange("present_address")}
                  />
                </div>
                <div className="col-md-6">
                  <CustomTextArea
                    id="other_detail"
                    label={"Other Details :"}
                    onChange={handleChange("other_detail")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <CustomInput
                    type={"file"}
                    id="image"
                    label={"Image :"}
                    onChange={handleChange("image")}
                  />
                </div>
              </div>
              <CustomButton type="submit" label="Save" isIcon />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
const mapActionWithProps = {
  addProfileData,
  getdepartmentData,
};

const mapStateWithProps = (state) => ({
  department: state.data.department,
});
export default connect(
  mapStateWithProps,
  mapActionWithProps
)(Users);
